Vue.directive('can', {
    inserted: function (el, binding) {
        if(!isAuthenticated || !hasPermission(binding.value)){
            el.style.display = 'none';
        }
    }
});

$('.check-permissions').each(function(){
    let is_permitted = hasPermission($(this).data('permissions').split('|'));

    if(!is_permitted){
        if($(this).is('form')){
            $(this).find('input,select,textarea,button')
                   .not('.ignore-permissions')
                   .not("[name='_token']")
                   .not("[name='_method']")
                   .attr('disabled', 'disabled');
        } else {
            $(this).attr('disabled', 'disabled');
        }
    }
});

function hasPermission(check_permissions){
    if(!Array.isArray(check_permissions)) {
        check_permissions = check_permissions.split('|');
    }

    if(check_permissions.length < 2){
        console.error('Permissions must be in format type1,type2|permission1,permission2');
        return false;
    }

    let types = check_permissions[0].split(',');
    check_permissions = check_permissions[1].split(',');

    types = types.map((type) => {
        return check_permissions.map((permission) => {
            return `${permission} - ${type}`;
        });
    }).reduce((acc, val) => acc.concat(val), [])

    return types.some(function(item){
        return permissions.indexOf(item) !== -1;
    });
}
